import React, { useState } from 'react'
import Sidebar from '../Layout/Sidebar';
import HeaderDashboard from '../Layout/HeaderDashboard';
import Overview from '../Pages/Overview';
import Transactions from '../Pages/Transactions'
import ChangePassword from '../Pages/ChangePassword';
import UpdateAddress from '../Pages/UpdateAddress';
import Userdata from '../Pages/Userdata';
import Transaction_history_mobile from '../Pages/Transaction_history_moblie';


export default function UserDashboard() {

    const [active, setActive] = useState('div1');

    return (
        <div className='flex flex-col min-h-screen bg-cover bg-[#111111] text-white'>
            <div className='flex flex-col lg:flex-row gap-2 lg:gap-0 w-full'>
                <div className='lg:w-[20%] h-full '>
                    <Sidebar active={active} setActive={setActive} />
                </div>
                <div className='flex flex-col w-[100%] lg:w-[80%]'>
                    <HeaderDashboard active={active} setActive={setActive}  />
                    <div className='overflow-y-auto mt-12'>
                        {active === 'div1' && <Overview />}
                        {active === 'div2' && <Transactions />}
                        {active === 'div3' && <ChangePassword/> }
                        {/* {active === 'div4' && <UpdateAddress/>} */}
                        {active === 'div5' && <Userdata/> }
                        {active === 'div6' && <Transaction_history_mobile/> }
                    </div>
                </div>
            </div>
        </div>
    )
}
